import Parse from 'parse'

const state = {
  countries: [],
  prefectures: [],
}

function sortObjects(objects) {
  return objects.sort((a, b) => {
    return a.get('index') - b.get('index')
  })
}

const getters = {
  countries: (state) => {
    return sortObjects(state.countries)
  },

  prefectures: (state) => {
    return sortObjects(state.prefectures)
  },
}

const mutations = {
  setCountries (state, countries) {
    state.countries = countries
  },

  setPrefectures (state, prefectures) {
    state.prefectures = prefectures
  },
}

const actions = {
  async retrieveCountries ({ commit }) {
    const query = new Parse.Query('Country')
    // とりあえず1000件取得する指定
    const limit_count = 1000
    commit('setCountries', await query.limit(limit_count).find())
  },

  async retrievePrefectures ({ commit, rootState }) {
    const country = rootState.user.country
    const query = new Parse.Query('Prefecture')
    query.equalTo('country', country)
    commit('setPrefectures', await query.find())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
